import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Use requestAnimationFrame for the most optimal timing
    const scrollToTop = () => {
      // Force immediate scroll to top to prevent any flash
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // Clear any other scroll containers
      const containers = document.querySelectorAll('[data-scroll-container], .chakra-ui-overflow');
      containers.forEach(container => {
        if (container instanceof HTMLElement) {
          container.scrollTop = 0;
        }
      });
    };

    // Execute immediately for instant scroll
    scrollToTop();

    // Additional cleanup in next frame for any late-loading content
    requestAnimationFrame(() => {
      scrollToTop();
    });

  }, [pathname]);

  return null;
};

export default ScrollToTop;